import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { OverlayService } from '@services/overlay';
import { CloseOverlayKeyboardDirective, CloseOverlayClickDirective } from '../../directives/close-overlay.directives';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { AttendancePhoto, Session } from 'src/app/queries/generated';
import { PhotoCommentsService } from '@services/photo-comments.service';

@Component({
  selector: 'lv-flag-photo',
  templateUrl: 'flag-photo.component.html',
  styleUrls: ['flag-photo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CloseOverlayKeyboardDirective, TranslateModule, FormsModule, CloseOverlayClickDirective]
})
export class FlagPhotoComponent {
  private photoCommentsService = inject(PhotoCommentsService);
  private overlayService = inject(OverlayService);

  @Input() photo: AttendancePhoto;
  @Input() session: Session;
  comment: string;

  submit() {
    this.photoCommentsService
      .create({
        attendancePhotoId: this.photo.id,
        photoComment: {
          sessionId: this.session.id,
          comment: this.comment
        }
      })
      .subscribe(() => {
        this.overlayService.closeTopOverlay();
      });
  }
}
